'use strict';

// Stylus
import 'stylesheets/styles.styl';

// Polyfills
import './vendors/modernizr-target';
import 'core-js';
// import 'object-assign-mdn';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// App
import 'managers/AppManager';
